/* This is the EMIS Giga components add 2025-26 */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>      
    </div>
    <div>
      <table
        style="height: 78px; width: 700px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 300px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សេវា​ Internet
            </td>
            <td
              style="
                width: 150px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
            ស្ថានភាព
            </td>
            <td
              style="
                width: 150px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
            ល្បឿន (Internet Speed)
            </td>
          </tr>
          <!--Row 1-->
          <tr>
            <td class="row-data-left">{{ intDesc[0] }}</td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[0].dt[0]"
                :items="yesNo2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, 0, 0)"
              >
              </v-select>
            </td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[0].dt[1]"
                :items="intSpeed"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect2($event, 0, 1)"
              >
              </v-select>
            </td>
          </tr>
          <!--Row 2-->
          <tr>
            <td class="row-data-left">{{ intDesc[1] }}</td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[1].dt[0]"
                :items="yesNo2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, 1, 0)"
              >
              </v-select>
            </td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[1].dt[1]"
                :items="intSpeed"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect2($event, 1, 1)"
              >
              </v-select>
            </td>
          </tr>        
          <!--Row 3-->
          <tr>
            <td class="row-data-left">{{ intDesc[2] }}</td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[2].dt[0]"
                :items="yesNo2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, 2, 0)"
              >
              </v-select>
            </td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[2].dt[1]"
                :items="intSpeed"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect2($event, 2, 1)"
              >
              </v-select>
            </td>
          </tr> 
          <!--Row 4-->
          <tr>
            <td class="row-data-left">{{ intDesc[3] }}</td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[3].dt[0]"
                :items="yesNo2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, 3, 0)"
              >
              </v-select>
            </td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[3].dt[1]"
                :items="intSpeed"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect2($event, 3, 1)"
              >
              </v-select>
            </td>
          </tr> 
          <!--Row 5-->
          <tr>
            <td class="row-data-left">{{ intDesc[4] }}</td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[4].dt[0]"
                :items="yesNo2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, 4, 0)"
              >
              </v-select>
            </td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[4].dt[1]"
                :items="intSpeed"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect2($event, 4, 1)"
              >
              </v-select>
            </td>
          </tr> 
          <!--Row 6-->
          <tr>
            <td class="row-data-left">{{ intDesc[5] }}</td>
            <td colspan="2" class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[5].dt[0]"
                :items="intType"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect3($event, 5, 0)"
              >
              </v-select>
            </td>
          </tr> 
          <!--Row 7-->
          <tr>
            <td class="row-data-left">{{ intDesc[6] }}</td>
            <td colspan="2" class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[6].dt[0]"
                :items="intMgt"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect3($event, 6, 0)"
              >
              </v-select>
            </td>
          </tr> 
          <!--Row 8-->
          <tr>
            <td class="row-data-left">{{ intDesc[7] }}</td>
            <td colspan="2" class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[7].dt[0]"
                :items="yesNo2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, 7, 0)"
              >
              </v-select>
            </td>
          </tr> 
          <!--Row 9-->
          <tr>
            <td class="row-data-left">{{ intDesc[8] }}</td>
            <td colspan="2" class="row-data">
              <numberinput v-model="data[8].dt[0]" class="number" />
            </td>
          </tr> 
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { yesNo2, intSpeed, intType, intDesc, intMgt} from "@/utils/ascf/commonConfig.js";
import NumberInput from "@/components/common/NumberInput.vue";

export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      yesNo2: yesNo2,
      intSpeed: intSpeed,
      intType: intType,
      intDesc: intDesc,
      intMgt: intMgt
    };
  },
  methods: {
    onSelect: function (event, r, c) {
      /* 2 options */
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[r].dt[c] = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect2: function (event, r, c) {
      /* 3 options */
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 51) {
        this.data[r].dt[c] = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect3: function (event, r, c) {
      /* 5 options */
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 53) {
        this.data[r].dt[c] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style scoped>
.number {
  width: 300px;
  text-align: left;
}
.row-data {
  width: 100px;
  height: 35px;
  text-align: center;
  vertical-align: middle;
}
.row-data-left {
  width: 200px;
  height: 35px;
  text-align: left;
  vertical-align: middle;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.v-input {
  font-size: 12px;
}
</style>